import { Trans, useLingui } from '@lingui/react/macro';

import FileUpload from '@/components/FileUpload';
import Button from '@/design_system/Button';
import Drawer, { DrawerBody, DrawerHeader } from '@/design_system/Drawer';
import { Footer, FooterButtons } from '@/design_system/Footer';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';
import { ErrorBoundary } from '@/services/sentry';

import { useArticleContext } from '../../contexts/ArticleContext';
import { useRequestContext } from '../../contexts/RequestContext';

import { CustomsFields } from './components/CustomsFields';

export const ArticleCustomsDrawer = () => {
  const { view: requestView } = useRequestContext();
  const { article, state, request, errors } = useArticleContext();
  const { t } = useLingui();

  return (
    <Drawer
      isOpen={state.customsPanel.isOpen}
      onOpenChange={() => state.customsPanel.setIsOpen(false)}
      style={{
        maxWidth: '31.25rem',
      }}
    >
      <DrawerHeader>
        <Title size="300" as="h1">
          <Trans id="article.customs.edit-title">Edit customs information</Trans>
        </Title>
      </DrawerHeader>

      <DrawerBody>
        <ErrorBoundary>
          <Stack gap="1rem" padding="1rem 1.5rem">
            {requestView.customs?.type === 'fields' && (
              <CustomsFields request={request} article={article} />
            )}
            {requestView.customs?.type === 'file' && (
              <FileUpload
                ariaLabel={t({
                  id: 'article.customs.customs-file.title',
                  message: 'Customs document',
                })}
                label={
                  <>
                    <Trans id="article.customs.customs-file.title">Customs document</Trans>
                  </>
                }
                media={article.media.filter(({ type }) => type === 'customs-file')}
                uploadData={{
                  type: 'customs-file',
                  articleId: article?.id,
                }}
                style={{ flex: '1' }}
                size="xlarge"
                deleteWithApi
                variant="grid"
                withQrCode
                type="file"
                secondaryActionIconOnly
                maxNumberOfMedia={1}
                error={
                  errors?.customs
                    ? t({
                        id: 'article.customs.customs-file.error',
                        message: 'Please add the customs document',
                      })
                    : undefined
                }
              />
            )}
          </Stack>
        </ErrorBoundary>
      </DrawerBody>

      <Footer>
        <FooterButtons>
          <Button onPress={() => state.customsPanel.setIsOpen(false)}>
            <Trans id="article.edit.save">Save</Trans>
          </Button>
        </FooterButtons>
      </Footer>
    </Drawer>
  );
};
